import { Directive, ElementRef, Injectable, Input, NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimationBuilder, animate, style } from '@angular/animations';
var ObserverServiceConfig = /** @class */ (function () {
    function ObserverServiceConfig() {
    }
    return ObserverServiceConfig;
}());
var ObserverService = /** @class */ (function () {
    /**
     * Assigns the user config if they wish to
     * override the defaults by using forRoot
     * @param {?} config
     */
    function ObserverService(config) {
        this.options = {
            rootMargin: '0px',
            threshold: 0.1
        };
        this.supported = false;
        this.watching = [];
        this.supported = 'IntersectionObserver' in window &&
            'IntersectionObserverEntry' in window;
        if (config) {
            this.options = Object.assign({}, this.options, config);
        }
        this.observer = this.supported ? new IntersectionObserver(this.handleEvent.bind(this), this.options) : null;
    }
    /**
     * Handles events made by the observer
     * @param {?} entries
     * @return {?}
     */
    ObserverService.prototype.handleEvent = function (entries) {
        var _this = this;
        entries.forEach(function (entry) {
            var /** @type {?} */ target = _this.watching.find(function (element) {
                return element.element === entry.target;
            });
            if (entry.isIntersecting) {
                _this.observer.unobserve(entry.target);
                target.callback(true);
            }
        });
    };
    /**
     * Adds the target to our array so we can call its
     * call back when it enters the viewport
     * @param {?} el
     * @param {?} callback
     * @return {?}
     */
    ObserverService.prototype.addTarget = function (el, callback) {
        this.observer.observe(el);
        this.watching.push({
            element: el,
            callback: callback
        });
    };
    /**
     * @return {?}
     */
    ObserverService.prototype.isSupported = function () {
        return this.supported;
    };
    return ObserverService;
}());
ObserverService.decorators = [
    { type: Injectable },
];
/**
 * @nocollapse
 */
ObserverService.ctorParameters = function () { return [
    { type: ObserverServiceConfig, decorators: [{ type: Optional },] },
]; };
var AnimateInDirective = /** @class */ (function () {
    /**
     * @param {?} _observer
     * @param {?} el
     * @param {?} animationBuilder
     */
    function AnimateInDirective(_observer, el, animationBuilder) {
        this._observer = _observer;
        this.el = el;
        this.animationBuilder = animationBuilder;
    }
    /**
     * @return {?}
     */
    AnimateInDirective.prototype.ngOnInit = function () {
        var /** @type {?} */ animation;
        if (this.animateInAnimation !== null && this.animateInAnimation !== undefined) {
            animation = this.animationBuilder.build(this.animateInAnimation);
        }
        else {
            animation = this.animationBuilder.build([
                style({ opacity: 0, transform: 'translateX(-100px)' }),
                animate('1200ms cubic-bezier(0.35, 0, 0.25, 1)', style({ opacity: 1, transform: 'translateX(0)' })),
            ]);
        }
        if (this._observer.isSupported()) {
            this.player = animation.create(this.el.nativeElement);
            this.player.init();
            this._observer.addTarget(this.el.nativeElement, this.startAnimating.bind(this));
        }
    };
    /**
     * Builds and triggers the animation
     * when it enters the viewport
     * @param {?} inViewport
     * @return {?}
     */
    AnimateInDirective.prototype.startAnimating = function (inViewport) {
        if (inViewport) {
            this.player.play();
        }
    };
    return AnimateInDirective;
}());
AnimateInDirective.decorators = [
    { type: Directive, args: [{
                selector: '[animateIn]'
            },] },
];
/**
 * @nocollapse
 */
AnimateInDirective.ctorParameters = function () { return [
    { type: ObserverService, },
    { type: ElementRef, },
    { type: AnimationBuilder, },
]; };
AnimateInDirective.propDecorators = {
    'animateInAnimation': [{ type: Input },],
};
var AnimateInModule = /** @class */ (function () {
    /**
     * @param {?} parentModule
     */
    function AnimateInModule(parentModule) {
        if (parentModule) {
            throw new Error('AnimateInModule is already loaded. Import it in the AppModule only');
        }
    }
    /**
     * @param {?=} config
     * @return {?}
     */
    AnimateInModule.forRoot = function (config) {
        return {
            ngModule: AnimateInModule,
            providers: [
                {
                    provide: ObserverServiceConfig, useValue: config
                }
            ]
        };
    };
    return AnimateInModule;
}());
AnimateInModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    CommonModule,
                ],
                exports: [
                    AnimateInDirective,
                ],
                declarations: [
                    AnimateInDirective
                ],
                providers: [
                    ObserverService
                ]
            },] },
];
/**
 * @nocollapse
 */
AnimateInModule.ctorParameters = function () { return [
    { type: AnimateInModule, decorators: [{ type: Optional }, { type: SkipSelf },] },
]; };
/**
 * Generated bundle index. Do not edit.
 */
export { AnimateInModule, AnimateInDirective, ObserverServiceConfig, ObserverService };
//# sourceMappingURL=ngx-animate-in.es5.js.map



//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/node_modules/ngx-animate-in/ngx-animate-in.es5.js
// module id = ../../../../ngx-animate-in/ngx-animate-in.es5.js
// module chunks = vendor